import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import detectIt from 'detect-it';
import { UserService } from '../../../../shared/services/user.service';

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss'],
})
export class StartComponent implements OnInit, OnDestroy {
  header = 'Bent u er klaar voor, Jesse?';

  circleTitleFirst =
    '<strong>U gaat op zoek naar:</strong> Tony chocolonely pakket.';
  circleImgFirst = 'assets/images/product1.png';

  circleTitleSecond: string;
  circleImgSecond = 'assets/images/product1.png';

  constructor(private router: Router, private userService: UserService) {}

  private timeOuts = [];

  mobile = false;

  @HostListener('window:resize')
  onResize() {
    this.checkDevice();
  }

  private checkDevice() {
    if (window.innerWidth < 992 || detectIt.deviceType === 'touchOnly') {
      this.mobile = true;
      this.circleTitleSecond =
        '<strong>Je krijgt last van glaucoom</strong> waardoor jouw gezichtsveld beperkt zal zijn.';
    } else {
      this.circleTitleSecond =
        '<strong>Je krijgt last van kokervisus</strong> waardoor jouw gezichtsveld beperkt zal zijn.';
      this.mobile = false;
    }
  }

  ngOnInit() {
    if (!this.userService.selectedProduct || !this.userService.user) {
      return this.router.navigate(['']);
    }
    this.checkDevice();

    this.header = `Ben je er klaar voor ${this.userService.user.firstName}?`;
    this.circleTitleFirst =
      '<strong>Je gaat op zoek naar:</strong> ' +
      this.userService.selectedProduct.name;
    this.circleImgFirst = this.userService.selectedProduct.imageURL;
    this.circleImgSecond = this.userService.selectedProduct.imageURL;
    document.body.classList.add('intro');
    document.body.classList.remove('game');
    // change image
    this.timeOuts.push(
      setTimeout(() => {
        const circleTop = document.getElementById('circle__top');
        const circleTopStepFirst = circleTop.getElementsByClassName('step-one');
        const circleTopStepSecond = circleTop.getElementsByClassName(
          'step-two'
        );

        circleTopStepFirst[0].classList.remove('visible');
        circleTopStepFirst[0].classList.add('hiden');

        circleTopStepSecond[0].classList.remove('hiden');
        circleTopStepSecond[0].classList.add('visible');
      }, 6400)
    );

    // change text
    this.timeOuts.push(
      setTimeout(() => {
        const circleContent = document.getElementById('circle__content');
        const circleContentStepFirst = circleContent.getElementsByClassName(
          'step-one'
        );
        const circleContentStepSecond = circleContent.getElementsByClassName(
          'step-two'
        );

        circleContentStepFirst[0].classList.remove('visible');
        circleContentStepFirst[0].classList.add('hiden');

        circleContentStepSecond[0].classList.remove('hiden');
        circleContentStepSecond[0].classList.add('visible');
      }, 6400)
    );

    // redirect after 10s
    this.timeOuts.push(
      setTimeout(() => {
        this.userService.startTime = new Date().getTime();
        this.router.navigate(['/shop']);
      }, 15000)
    );
  }

  ngOnDestroy(): void {
    this.timeOuts.forEach(timeout => {
      clearTimeout(timeout);
    });
  }
}
